export default __webpack_public_path__ + "static/media/2301012002A00103.6ba63bf2.pdf";